exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".track__slick-track__2vOSc{display:-ms-flexbox;display:flex}", ""]);

// exports
exports.locals = {
	"slick-track": "track__slick-track__2vOSc",
	"slickTrack": "track__slick-track__2vOSc"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/mobile-carousel/track.styl
// module id = 2914
// module chunks = 1